/* ========================================================================
 * FD:          FD
 * Child:       --
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * calendar plugin
 * ======================================================================== 
 * 7/20/2016: creation
*/

FD.PLUGIN = (function ($, me) {
    'use strict';

    var pluginName = 'FDCalendar';

    var defaults = {
        displayDate: new Date(),
        dayHeight: '80px',
        onFoo: function () { },
        dataAR: []
    };

    //  object fdCalendar
    function FDCalendar(element, options) {
        this._elem = $(element);    
        this._defaults = defaults;
        this._name = pluginName;
        this._dayAR = [];
        this._htmlAR = [];

        //  handle options
        if (options) { }

        this.options = $.extend({}, defaults, options);
        this.startDate = this.options.displayDate;

        this._buildDayArray();
        this._drawCalendar();
        this._convertData();
        this._initCalendar();
    }


    //  the calendar
    FDCalendar.prototype = {

        //  build the day array for the month showing
        _buildDayArray: function () {
            this._dayAR = [];
            var firstDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), 1);
            var firstDayNum = firstDate.getFirstDayNumber();
            if (firstDayNum === 0) firstDayNum = 7;

            var startDate = firstDate.setDate(firstDate.getDate() - firstDayNum);

            for (var i = 0; i < 42; i++) {
                var temp = new Date(startDate);
                var curDate = new Date(temp.addDay(i));
                var item = {
                    theDate: curDate,
                    dayNumber: curDate.getDate(),
                    isTodayClass: (curDate.isEqual(new Date())) ? "day-cell-today" : "",
                    dayClass: (curDate.getMonth() !== this.startDate.getMonth()) ? "day-cell-extra" : "day-cell"
                };

                this._dayAR.push(item);
            }
        },


        //  draw the calendar
        _drawCalendar: function(){
            this._htmlAR.push(
                "<div class='fd-calendar'>",
                "<div class='box box-default pb-5'>",
                "<div class='box-content'>"
                );

            this._htmlAR.push(
                "<div class='calendar-header'>",
                "<ul class='list-inline pull-left'>",
                "<li><h3 id='CALENDAR_DATE' class='text-bold'>" + this.startDate.getMonthDateFriendlyFull() + "</h3></li>",
                "</ul>",
                "<ul class='list-inline pull-right'>",
                "<li><a href='#' data-fd='button' data-tag='6' data-useparent='false' data-parentid='1'><i class='fa fa-dot-circle-o fa-fw fa-lg'></i></a></li>",
                "<li><a href='#' data-fd='button' data-tag='5' data-useparent='false' data-parentid='-1'><i class='fa fa-caret-left fa-fw fa-lg'></i></a></li>",
                "<li><a href='#' data-fd='button' data-tag='5' data-useparent='false' data-parentid='1'><i class='fa fa-caret-right fa-fw fa-lg'></i></a></li>",
                "</ul>",
                "</div>",
                "<div id='CALENDAR_DATA'></div>"
            );

            this._htmlAR.push(
                "</div>",
                "</div>",
                "</div>"
                );

            this._elem.html(this._htmlAR.join(''));
        },


        //  convert the dates from SQL
        _convertData: function () {
            var aR = [];

            for (var i = 0, len = this.options.dataAR.length; i < len; i++) {
                var d = this.options.dataAR[i];
                const mDate = moment(d.DateValueString, 'MM-DD-YYYY');
                const theDate = mDate.utc().toDate();

                aR.push(theDate);
            }

            this.options.dataAR = aR;
        },

        //  find if date is active
        _getIsActive: function (checkDate) {         
            for (var i = 0, len = this.options.dataAR.length; i < len; i++) {
                var d = this.options.dataAR[i];               
                if (checkDate.theDate.isEqual(d)) return true;         
            }

            return false;
        },


        //  init calendar
        _initCalendar: function () {
            var result = [];
            result.push("<ul class='calendar-row list-unstyled list-inline'>");

            for (var i = 0, len = this._dayAR.length; i < len; i++) {
                var d = this._dayAR[i];
                var isActive = (this._getIsActive(d)) ? 'active' : '';

                result.push(
                    "<li class='day " + d.dayClass + ' ' + d.isTodayClass + ' ' + isActive + "'  data-parent='true' data-parentid='" + d.theDate.getDateFriendly() +  "' style='height:45px'>",
                    "<div class='content'>",
                    "<a href='#' data-fd='button' data-tag='111'>" + d.dayNumber + "</a>",
                    "</div>",
                    "</li>"
                    );
            }
            result.push("</ul>");

            $('#CALENDAR_DATA').html(result.join(''));
        },


        //  
        MakeCalendar: function (theDate, data) {
            this.startDate = theDate;
            this.options.dataAR = data;
            this._buildDayArray();
            this._convertData();
            this._initCalendar();
          
            $('#CALENDAR_DATE').html(this.startDate.getMonthDateFriendlyFull());
        }
    };


    // attach plugin
    $.fn[pluginName] = function (options) {
        
        var result = this.each(function () {
            if (undefined === $(this).data(pluginName)) {

                var fdCalendar = new FDCalendar(this, options);

                $(this).data(pluginName, fdCalendar);
            }
        });

        return result;
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return me;
}(jQuery, FD));